import {CCE_CLUSTER_LIST_LINK} from '@/links';
import ExternalLink from '@/components/ExternalLink';
import noData from '@/assets/no-data.svg';
import c from './noDataSelectCluster.less';
export default function NoDataSelectCluster() {
    return (
        <div className={c.noDataSelect}>
            <img src={noData} />
            <h2>暂无数据</h2>
            <div>
                <span>没有可以选择的集群，请点击创建CCE集群。</span>
                <ExternalLink href={CCE_CLUSTER_LIST_LINK} value="创建集群" />
            </div>
        </div>
    );
}
